import{jsx as t}from"react/jsx-runtime";const r=({name:r,logoUrl:e,size:i="38px"})=>"string"==typeof e?/*#__PURE__*/t("img",{src:e,alt:`${r??"Provider app"} logo`,style:{width:i,height:i,maxHeight:"90px",maxWidth:"180px",borderRadius:"8px"}}):
/*#__PURE__*/t("span",{});export{r as ProviderAppLogo};
